<template>
    <div class="w-98 p-2">
        <div class="p-1" >
			<!-- div class="col-12 tituloJanelaPequena text-center mb-2" style="letter-spacing: 1px">
				CDOE - Coordenação de Doenças, viroses e bactérias
			</div -->

			<!-- Parte de Projetos -->
            <div class="row ml-1">

				<div class="col-4">

					<div class="col janelaPequena" @click="irProjeto()">
						<div class="row">
							<div class="col-5">
								<div class="ml-2 tituloJanelaPequena">
									<i class="fas fa-calendar-alt mr-1"></i>Projetos ({{ qntdProjeto }})
								</div>
								<div class="ml-4">
									<Torta v-if="datasetProjeto" :styles=" {'height': '90px', 'margin-left': '-5px'}" :chartdata="datasetProjeto" :options="optionsTorta" class="grafico-pequeno"></Torta>
								</div>
							</div>
							<div class="col-7">
								<div class="tituloJanelaPequena">
									<div class="mt-1 ml-4">
										<table style="line-height: 1.1;">
											<tr v-for="situacao in listaSituacaoProjeto" :key="situacao.codigo" v-if="datasetProjeto!=null">
												<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> <span class="ml-3">{{situacao.descricao}}</span> </td><td class="text-right pl-1"> <span class="ml-3">{{situacao.porcento}}%</span> </td>
											</tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row" style="align-items: center; justify-content: center; text-align: center;">
						
						<div class="col m-1 mt-2">
							<el-tooltip content="Projetos aguardando aprovação do coordenador" placement="top">
								<div class="quadroPequenoCoord clickable" @click="abrirDetalhes('projeto-analise', 'Projetos em análise', 'projeto')"
										:class="(projetosPendentes[0] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
									<div class="col-12 tituloQuadroPequenoCoord text-center">
										Projetos em análise
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(projetosPendentes[0] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[0] > 0) ? 'fonte-pendencia' : ''">
										{{ projetosPendentes[0] }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col m-1 mt-2">
							<el-tooltip content="Projetos com pendência não validado pelo coordenador" placement="top">
								<div class="quadroPequenoCoord clickable" @click="abrirDetalhes('projeto-devolvido', 'Projetos devolvidos', 'projeto')"
										:class="(projetosPendentes[1] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
									<div class="col-12 tituloQuadroPequenoCoord text-center">
										Projetos devolvidos
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(projetosPendentes[1] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[1] > 0) ? 'fonte-pendencia' : ''">
										{{ projetosPendentes[1] }}
									</div>
								</div>
							</el-tooltip>
						</div>
					
					</div>
					<div class="row" style="align-items: center; justify-content: center; text-align: center;">

						<div class="col m-1">
							<el-tooltip content="Quantidade de projetos atrasados" placement="top">
								<div class="quadroPequenoCoord clickable" @click="abrirDetalhes('projeto-atrasado', 'Projetos atrasados', 'projeto')"
										:class="(listaSituacaoProjeto.length > 0 && listaSituacaoProjeto[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
									<div class="col-12 tituloQuadroPequenoCoord text-center">
										Projetos atrasados
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(listaSituacaoProjeto[2] == null) ? 'dadoAltoOff' : (listaSituacaoProjeto[2].quantidade > 0) ? 'fonte-pendencia' : ''">
										{{ listaSituacaoProjeto[2].quantidade }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col m-1">
							<el-tooltip content="Projetos terminando nos próximos 30 dias" placement="top">
								<div class="quadroPequenoCoord clickable" @click="abrirDetalhes('projeto-proximo', 'Projetos próximos — 30 dias', 'projeto')">
									<div class="col-12 tituloQuadroPequenoCoord text-center">
										Projetos Próximos<br/><div style="margin-top: -7px; font-weight: bold;">30 dias</div>
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(patProxDias[0] ==='!?') ? 'dadoAltoOff' : ''">
										{{patProxDias[0]}}
									</div>
								</div>
							</el-tooltip>
						</div>

					</div>

				</div>
				<div class="col-8">

					<div class="col-12 fonte-13 tituloQuadroPequeno" style="text-align: center;">Total de Projetos por {{ nomeAgrupamento }}</div>
					<div class="col-12 mt--4 clickable" @click="irProjeto()">
						<Barra v-if="datasetProjetoPorGT" :chartdata="datasetProjetoPorGT" :options="optionsBarraProjeto" class="grafico-proj-gt"></Barra>
					</div>
					
				</div>
				<div class="col-12">

					<!-- CARROSSEL DE PROJETOS POR GT -->
					<div style="color: #8c9db3; text-align: center; height: 160px;" v-if="carregandoProjetoCarrossel">
						<div style="margin-top: 160px;">
							<span class="spinner-border spinner-border-sm mr-2" role="status">
								<span class="sr-only">Loading...</span>
							</span>Carregando {{ nomeAgrupamentoPlural }} e seus Projetos...
						</div>
					</div>
					<hooper style="height: 320px;" v-if="!carregandoProjetoCarrossel && this.listaGTCarrossel.length > 0">
						<slide v-for="(gt, index) in listaGTCarrossel" :key="agrupamentoId(gt)">
							<div class="row mt-2 bg-light">
								<div class="col-12 font-bold-500 mb-2 text-center">
									<strong>Projetos da {{ agrupamentoNome(gt) }}</strong>
								</div>
								<div class="col-4">
									<div class="fonte-13 tituloJanelaPequena ml-4">
										Situação dos projetos ({{ gt.qntdProjetos }})
									</div>
									<div>
										<Donuts v-if="datasetSituacaoProjetoGT[index]" :chartdata="datasetSituacaoProjetoGT[index]" :options="optionsDonut" class="grafico-situacao"></Donuts>
									</div>
								</div>
								<div class="col-8">
									<div class="row">
										<div class="col-12 fonte-13 tituloJanelaPequena">
											Próximos Projetos de relevância "muito alta"
										</div>
									</div>
									<table class="table table-hover" style="margin-left: -30px;">
										<tr v-for="projeto in gt.listaProjetos" :key="projeto.idprojeto">
											<td class="tdListaAtividade">
												<div>
													<el-tooltip :content="projeto.codigoNome" placement="top">
														<strong class="clickable" @click="abrirModalProjeto(projeto)">
															{{ projeto.titulo.trim().substring(0, 70) }}{{ projeto.titulo.length > 70 ? "..." : "" }}
														</strong>
													</el-tooltip>
												</div>
												<div style="margin-top: -20px;" :class="'font-' + projeto.situacao"
													v-if="projeto.situacao == 'CONCLUIDO' || projeto.situacao == 'CANCELADO'"><br />
													{{ projeto.situacaoDescricao }} (em {{ projeto.dataConclusao }})
												</div>
												<div style="margin-top: -20px;" class="font-atrasada" v-if="projeto.situacao == 'ATRASADO'"><br />
													{{ projeto.situacaoDescricao }} ({{projeto.atraso}})
												</div>
												<el-tooltip :content="projeto.progresso + '%'" placement="top"
														v-if="projeto.situacao == 'EMANDAMENTO'">
													<div class="progress mt-1 w-100">
														<div class="progress-bar" role="progressbar"
															:style="'font-size: 11px; height: 3px; width: ' + projeto.progresso + '%;'"
															:class="'progresso-' + projeto.situacao">
														</div>
													</div>
												</el-tooltip>
											</td>
											<td :class="(projeto.reagendado) ? 'font-reagenda' : ''">
												<i class="far fa-calendar-alt"></i>
												{{ projeto.dataInicio }} a {{ projeto.dataFim }}
											</td>
										</tr>
									</table>  
								</div>
								<div class="bg-light" style="height: 25px;">
									&nbsp;
								</div>
							</div>
						</slide>
						
						<hooper-navigation slot="hooper-addons"></hooper-navigation>
						<hooper-pagination slot="hooper-addons"></hooper-pagination>
					</hooper>

				</div>

			</div>

			<!-- Parte de Atividades -->
            <div class="row ml-1">

				<div class="col-4">

					<div class="col mt-2 janelaPequena" @click="irAtividade()">
						<div class="row">
							<div class="col-5">
								<div class="ml-2 tituloJanelaPequena">
									<i class="fas fa-calendar-alt mr-1"></i>Atividades ({{ qntdAtividade }})
								</div>
								<div class="ml-4">
									<Torta v-if="datasetAtividade" :styles=" {'height': '90px', 'margin-left': '-5px'}" :chartdata="datasetAtividade" :options="optionsTorta" class="grafico-pequeno"></Torta>
								</div>
							</div>
							<div class="col-7">
								<div class="tituloJanelaPequena">
									<div class="mt-1 ml-4">
										<table style="line-height: 1.1;">
											<tr v-for="situacao in listaSituacaoAtividade" :key="situacao.codigo" v-if="datasetAtividade!=null">
												<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> <span class="ml-3">{{situacao.descricao}}</span> </td><td class="text-right pl-1"> <span class="ml-3">{{situacao.porcento}}%</span> </td>
											</tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciadas</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasadas</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Canceladas</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídas</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row" style="align-items: center; justify-content: center; text-align: center;">
						
						<div class="col m-1 mt-3">
							<el-tooltip content="Quantidade de atividades atrasadas" placement="top">
								<div class="quadroPequeno clickable" @click="abrirDetalhes('atividade-atrasada', 'Atividades atrasadas', 'atividade')"
										:class="(listaSituacaoAtividade.length > 0 && listaSituacaoAtividade[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
									<div class="col-12 mt-2 fonte-13 tituloQuadroPequeno text-center">
										Atividades atrasadas
									</div>
									<div class="col-12 mt--3 text-center font-weight-bold fonte-media"
										:class="(listaSituacaoAtividade[2].quantidade == null) ? 'dadoAltoOff' : (listaSituacaoAtividade[2].quantidade > 0) ? 'fonte-pendencia' : ''">
										{{ listaSituacaoAtividade[2].quantidade }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col m-1 mt-3">
							<el-tooltip content="Atividades terminando nos próximos 15 dias" placement="top">
								<div class="quadroPequeno clickable" @click="abrirDetalhes('atividade-proxima', 'Atividades próximas — 15 dias', 'atividade')">
									<div class="col-12 mt-2 fonte-13 tituloQuadroPequeno text-center">
										Atividades próximas<br/><div style="margin-top: -7px; font-weight: bold;">15 dias</div>
									</div>
									<div class="col-12 mt--3 text-center font-weight-bold fonte-media"
										:class="(patProxDias[1] ==='!?') ? 'dadoAltoOff' : ''">
										{{patProxDias[1]}}
									</div>
								</div>
							</el-tooltip>
						</div>

					</div>

				</div>
				<div class="col-8">

					<div class="col-12 fonte-13 tituloQuadroPequeno" style="text-align: center;">Quantidade de Atividades por {{ nomeAgrupamento }}</div>
					<div class="col-12 mt--4 clickable" @click="irAtividade()">
						<Barra v-if="datasetAtvProgramadaPorGT" :chartdata="datasetAtvProgramadaPorGT" :options="optionsBarraAtividade" class="grafico-proj-gt"></Barra>
					</div>
					
				</div>

				<div class="col-12">
					<div class="row">
						<div class="col">
							<el-tooltip content="Recurso Disponibilizado" placement="top">
								<div class="quadroPequenoInvestimento">
									<div class="col-12 fonte-13 tituloQuadroPequenoInvestimento text-center">
										<i class="fas fa-dollar-sign mr-1"></i> 
										Recurso Disponibilizado
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(investimentoGT === 'R$ 888.88') ? 'dadoAltoOff' : ''">
										{{ formatarMoeda(investimentoGT) }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col">
							<el-tooltip content="Investimentos das Atividades Em Aberto" placement="top">
								<div class="quadroPequenoInvestimento">
									<div class="col-12 fonte-13 tituloQuadroPequenoInvestimento text-center">
										<i class="fas fa-dollar-sign mr-1"></i> 
										Investimento Programado
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(investimento[0] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
										{{ formatarMoeda(investimento[0]) }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col">
							<el-tooltip content="Investimentos das Atividades Encerradas" placement="top">
								<div class="quadroPequenoInvestimento">
									<div class="col-12 fonte-13 tituloQuadroPequenoInvestimento text-center">
										<i class="fas fa-dollar-sign mr-1"></i>
										Investimento Realizado
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(investimento[1] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
										{{ formatarMoeda(investimento[1]) }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col">
							<el-tooltip content="Investimentos das Atividades não programado" placement="top">
								<div class="quadroPequenoInvestimento">
									<div class="col-12 fonte-13 tituloQuadroPequenoInvestimento text-center">
										<i class="fas fa-dollar-sign mr-1"></i>
										Saldo Disponível
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(investimento[2] ==='R$ 888.88') ? 'dadoAltoOff' : ''">
										{{ formatarMoeda(investimento[2]) }}
									</div>
								</div>
							</el-tooltip>
						</div>
						<div class="col">
							<el-tooltip content="Investimentos das Atividades Não Empenhado" placement="top">
								<div class="quadroPequenoInvestimento">
									<div class="col-12 fonte-13 tituloQuadroPequenoInvestimento text-center">
										<i class="fas fa-dollar-sign mr-1"></i> 
										Invest. Não Empenhado
									</div>
									<div class="col-12 text-center font-weight-bold fonte-media"
										:class="(investimento[3] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
										{{ formatarMoeda(investimento[3]) }}
									</div>
								</div>
							</el-tooltip>
						</div>
					</div>
				</div>

				<div class="col-12">

					<!-- CARROSSEL DE ATIVIDADES DESTAQUE POR GT -->
					<div style="color: #8c9db3; text-align: center; height: 160px;" v-if="carregandoAtividadeCarrossel">
						<div style="margin-top: 160px;">
							<span class="spinner-border spinner-border-sm mr-2" role="status">
								<span class="sr-only">Loading...</span>
							</span>Carregando Atividades por {{ nomeAgrupamentoPlural }}...
						</div>
					</div>
					<hooper style="height: 320px;" v-if="!carregandoAtividadeCarrossel && this.listaGTAtividadeCarrossel.length > 0">
						<slide v-for="(gt, index) in listaGTAtividadeCarrossel" :key="agrupamentoId(gt)">
							<div class="row mt-2 bg-light">
								<div class="col-12 font-bold-500 mb-2 text-center">
									<strong>Atividades da {{ agrupamentoNome(gt) }}</strong>
								</div>
								<div class="col-4">
									<div class="tituloJanelaPequena ml-4 fonte-13">
										Situação das atividades ({{  gt.qntdProjetos }})
									</div>
									<div>
										<Donuts v-if="datasetSituacaoAtividadeGT[index]" :chartdata="datasetSituacaoAtividadeGT[index]" :options="optionsDonut" class="grafico-situacao"></Donuts>
									</div>
								</div>
								<div class="col-8">
									<div class="row">
										<div class="col-12 fonte-13 tituloJanelaPequena">
											Próximas Atividades de Destaque <i class="text-warning fas fa-star mr-1"></i>
										</div>
									</div>
									<table class="table table-hover" style="margin-left: -30px;">
										<tr v-for="atividade in gt.listaAtividades" :key="atividade.idatividade">
											<td class="tdListaAtividade">
												<div class="text-wrap">
													<el-tooltip v-if="atividade.destaque" 
															content="Atividade em destaque" placement="top">
														<i class="text-warning fas fa-star mr-1"></i>
													</el-tooltip>
													<el-tooltip :content="atividade.codigoNome" placement="top">
														<strong class="clickable" @click="abrirModalAtividade(atividade)">
															{{ atividade.titulo.trim().substring(0, 70) }}{{ atividade.titulo.length > 70 ? "..." : "" }}
														</strong>
													</el-tooltip>
												</div>
												<div style="margin-top: -20px;" :class="'font-' + atividade.situacao"
													v-if="atividade.situacao == 'CONCLUIDA' || atividade.situacao == 'CANCELADA'"><br />
													{{ atividade.situacaoDescricao }} (em {{ atividade.dataConclusao }})
												</div>
												<div style="margin-top: -20px;" class="font-atrasada" v-if="atividade.situacao == 'ATRASADA'"><br />
													{{ atividade.situacaoDescricao }} ({{atividade.atrasada}})
												</div>
												<el-tooltip :content="atividade.progresso + '%'" placement="top"
														v-if="atividade.situacao == 'EMANDAMENTO'">
													<div class="progress mt-1 w-100">
														<div class="progress-bar" role="progressbar"
															:style="'font-size: 11px; height: 3px; width: ' + atividade.progresso + '%;'"
															:class="'progresso-' + atividade.situacao">
														</div>
													</div>
												</el-tooltip>
											</td>
											<td :class="(atividade.reagendada) ? 'font-reagenda' : ''">
												<i class="far fa-calendar-alt"></i>
												{{ atividade.dataInicio }} a {{ atividade.dataFim }}
											</td>
										</tr>
									</table>  
								</div>
								<div class="bg-light" style="height: 25px;">
									&nbsp;
								</div>
							</div>
						</slide>
						
						<hooper-navigation slot="hooper-addons"></hooper-navigation>
						<hooper-pagination slot="hooper-addons"></hooper-pagination>
					</hooper>

				</div>
			</div>

		</div>

		<!--
		<div class="row ml-1" style="align-items: center; justify-content: center; text-align: center;">
			
			<div class="col-4">
				<div class="janelaPequena" @click="irProjeto()">
					<div class="row">
						<div class="col-5">
							<div class="ml-2 tituloJanelaPequena">
								<i class="fas fa-calendar-alt mr-1"></i>Projetos ({{ qntdProjeto }})
							</div>
							<div class="ml-4">
								<Torta v-if="datasetProjeto" :styles=" {'height': '90px', 'margin-left': '-5px'}" :chartdata="datasetProjeto" :options="optionsTorta" class="grafico-pequeno"></Torta>
							</div>
						</div>
						<div class="col-7">
							<div class="tituloJanelaPequena">
								<div class="mt-1 ml-4">
									<table style="line-height: 1.1;">
										<tr v-for="situacao in listaSituacaoProjeto" :key="situacao.codigo" v-if="datasetProjeto!=null">
											<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> <span class="ml-3">{{situacao.descricao}}</span> </td><td class="text-right pl-1"> <span class="ml-3">{{situacao.porcento}}%</span> </td>
										</tr>
										<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-4">
				<div class="janelaPequena" @click="irAtividade()">
					<div class="row">
						<div class="col-5">
							<div class="ml-2 tituloJanelaPequena">
								<i class="fas fa-calendar-alt mr-1"></i>Atividades ({{ qntdAtividade }})
							</div>
							<div class="ml-4">
								<Torta v-if="datasetAtividade" :styles=" {height: '90px' }" :chartdata="datasetAtividade" :options="optionsTorta" class="grafico-pequeno"></Torta>
							</div>
						</div>
						<div class="col-7">
							<div class="tituloJanelaPequena">
								<div class="mt-1 ml-4">
									<table style="line-height: 1.1;">
										<tr v-for="situacao in listaSituacaoAtividade" :key="situacao.codigo" v-if="datasetAtividade!=null">
											<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> <span class="ml-3">{{situacao.descricao}}</span> </td><td class="text-right pl-1"> <span class="ml-3">{{situacao.porcento}}%</span> </td>
										</tr>
										<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-4">
				<div class="janelaPequena" @click="irAtividade()">
					<div class="row">
						<div class="col-5">
							<div class="ml-2 tituloJanelaPequena">
								<i class="fas fa-calendar-alt mr-1"></i> Tarefas ({{ qntdTarefa }})
							</div>
							<div class="ml-4">
								<Torta v-if="datasetTarefa" :styles=" {height: '90px' }" :chartdata="datasetTarefa" :options="optionsTorta" class="grafico-pequeno"></Torta>
							</div>
						</div>
						<div class="col-7">
							<div class="tituloJanelaPequena">
								<div class="mt-1 ml-4">
									<table style="line-height: 1.1;">
										<tr v-for="situacao in listaSituacaoTarefa" :key="situacao.codigo" v-if="datasetTarefa!=null">
											<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> <span class="ml-3">{{situacao.descricao}}</span> </td><td class="text-right pl-1"> <span class="ml-3">{{situacao.porcento}}%</span> </td>
										</tr>
										<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="p-1">
            <div class="row">
                <div class="col">
					<el-tooltip content="Projetos aguardando aprovação do coordenador" placement="top">
						<div class="quadroPequeno clickable" @click="irProjeto()"
								:class="(projetosPendentes[0] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos em<br/>análise
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(projetosPendentes[0] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[0] > 0) ? 'fonte-pendencia' : ''">
								{{ projetosPendentes[0] }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Projetos com pendência não validado pelo coordenador" placement="top">
						<div class="quadroPequeno clickable" @click="irProjeto()"
								:class="(projetosPendentes[1] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos<br/>devolvidos
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(projetosPendentes[1] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[1] > 0) ? 'fonte-pendencia' : ''">
								{{ projetosPendentes[1] }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Quantidade de projetos atrasados" placement="top">
						<div class="quadroPequeno clickable" @click="irProjeto()"
								:class="(listaSituacaoProjeto.length > 0 && listaSituacaoProjeto[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos<br/>atrasados
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetProjeto==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoProjeto[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Quantidade de atividades atrasadas" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()"
								:class="(listaSituacaoAtividade.length > 0 && listaSituacaoAtividade[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Atividades<br/>atrasadas
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetAtividade==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoAtividade[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Quantidade de tarefas atrasadas" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()"
								:class="(listaSituacaoTarefa.length > 0 && listaSituacaoTarefa[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Tarefas<br/>atrasadas
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetTarefa==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoTarefa[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Projetos terminando nos próximos 30 dias" placement="top">
						<div class="quadroPequeno clickable" @click="irProjeto()">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos próximos<br/><strong>30 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[0] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[0]}}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Atividades terminando nos próximos 15 dias" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()">
							<div class="col-12 tituloQuadroPequeno text-center">
								Atividades próximos<br/><strong>15 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[1] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[1]}}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Tarefas terminando nos próximos 10 dias" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()">
							<div class="col-12 tituloQuadroPequeno text-center">
								Tarefas próximos<br/><strong>10 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[2] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[2]}}
							</div>
						</div>
					</el-tooltip>
                </div>


                
            </div>
        </div>
		-->

		<!--
		<hooper style="height: 380px;">
			<slide>
				<div class="row mt-2 bg-light">
					<div class="col-12 font-bold-500 mb-2 text-center">
						<strong>Grupo de Trabalho - Grupo de Doenças Infectocontagiosas</strong>
					</div>
					<div class="col-5">
						<div class="tituloJanelaPequena ml-4">
							Investimentos (Projetos em aberto)
						</div>
						<div class="tituloJanelaPequena">
							&nbsp;&nbsp;
						</div>
						<div>
							<Barra :chartdata="datasetInvestPorGT" :options="optionsBarraInvertido" class="grafico-invgt"></Barra>
						</div>
					</div>
					<div class="col-7">
						<div>
							<div class="row">
								<div class="col-6 tituloJanelaPequena">
									Projetos em aberto
								</div>
								<div class="col-6 text-right tituloJanelaPequena">
									Outros projetos
								</div>
							</div>
							<table class="table table-hover mt-2">
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 75%" 
												style="font-size: 11px; height: 3px; width: 75%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 15.420,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00142 - Erradicação da Covid em âmbito nacional
										</span>
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/11/2021 a 02/12/2021
									</td>
									<td class="text-right">
										R$ 302,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00133 - Teste de Projeto para incluir responsáveis e GT 
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 25%" 
												style="font-size: 11px; height: 3px; width: 25%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										12/10/2021 a 14/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 33%" 
												style="font-size: 11px; height: 3px; width: 33%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
							</table>  
						</div>
					</div>
					<div class="bg-light" style="height: 25px;">
						&nbsp;
					</div>
				</div>
			</slide>
			<slide>
				<div class="row mt-2 bg-light">
					<div class="col-12 font-bold-500 mb-2 text-center">
						<strong>Grupo de Trabalho - Grupo Paramilitar do Leste</strong>
					</div>
					<div class="col-5">
						<div class="tituloJanelaPequena ml-4">
							Investimentos (Projetos em aberto)
						</div>
						<div class="tituloJanelaPequena">
							&nbsp;&nbsp;
						</div>
						<div>
							<Barra :chartdata="datasetInvestPorGT" :options="optionsBarraInvertido" class="grafico-invgt"></Barra>
						</div>
					</div>
					<div class="col-7">
						<div>
							<div class="row">
								<div class="col-6 tituloJanelaPequena">
									Projetos em aberto
								</div>
								<div class="col-6 text-right tituloJanelaPequena">
									Outros projetos
								</div>
							</div>
							<table class="table table-hover mt-2">
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 75%" 
												style="font-size: 11px; height: 3px; width: 75%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 15.420,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00142 - Erradicação da Covid em âmbito nacional
										</span>
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/11/2021 a 02/12/2021
									</td>
									<td class="text-right">
										R$ 302,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00133 - Teste de Projeto para incluir responsáveis e GT 
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 25%" 
												style="font-size: 11px; height: 3px; width: 25%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										12/10/2021 a 14/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 33%" 
												style="font-size: 11px; height: 3px; width: 33%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
							</table>  
						</div>
					</div>
					<div class="bg-light" style="height: 25px;">
						&nbsp;
					</div>
				</div>
			</slide>
			<slide>
				<div class="row mt-2 bg-light">
					<div class="col-12 font-bold-500 mb-2 text-center">
						<strong>Grupo de Trabalho - Grupo Especial COVID</strong>
					</div>
					<div class="col-5">
						<div class="tituloJanelaPequena ml-4">
							Investimentos (Projetos em aberto)
						</div>
						<div class="tituloJanelaPequena">
							&nbsp;&nbsp;
						</div>
						<div>
							<Barra :chartdata="datasetInvestPorGT" :options="optionsBarraInvertido" class="grafico-invgt"></Barra>
						</div>
					</div>
					<div class="col-7">
						<div>
							<div class="row">
								<div class="col-6 tituloJanelaPequena">
									Projetos em aberto
								</div>
								<div class="col-6 text-right tituloJanelaPequena">
									Outros projetos
								</div>
							</div>
							<table class="table table-hover mt-2">
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 75%" 
												style="font-size: 11px; height: 3px; width: 75%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 15.420,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00142 - Erradicação da Covid em âmbito nacional
										</span>
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/11/2021 a 02/12/2021
									</td>
									<td class="text-right">
										R$ 302,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00133 - Teste de Projeto para incluir responsáveis e GT 
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 25%" 
												style="font-size: 11px; height: 3px; width: 25%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										12/10/2021 a 14/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 33%" 
												style="font-size: 11px; height: 3px; width: 33%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
							</table>  
						</div>
					</div>
					<div class="bg-light" style="height: 25px;">
						&nbsp;
					</div>
				</div>
			</slide>
			<slide>
				<div class="row mt-2 bg-light">
					<div class="col-12 font-bold-500 mb-2 text-center">
						<strong>Grupo de Trabalho - Grupo de Doenças Sexuais</strong>
					</div>
					<div class="col-5">
						<div class="tituloJanelaPequena ml-4">
							Investimentos (Projetos em aberto)
						</div>
						<div class="tituloJanelaPequena">
							&nbsp;&nbsp;
						</div>
						<div>
							<Barra :chartdata="datasetInvestPorGT" :options="optionsBarraInvertido" class="grafico-invgt"></Barra>
						</div>
					</div>
					<div class="col-7">
						<div>
							<div class="row">
								<div class="col-6 tituloJanelaPequena">
									Projetos em aberto
								</div>
								<div class="col-6 text-right tituloJanelaPequena">
									Outros projetos
								</div>
							</div>
							<table class="table table-hover mt-2">
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 75%" 
												style="font-size: 11px; height: 3px; width: 75%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 15.420,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00142 - Erradicação da Covid em âmbito nacional
										</span>
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/11/2021 a 02/12/2021
									</td>
									<td class="text-right">
										R$ 302,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00133 - Teste de Projeto para incluir responsáveis e GT 
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 25%" 
												style="font-size: 11px; height: 3px; width: 25%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										12/10/2021 a 14/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
								<tr>
									<td>
										<span class="text-wrap">
											PR2021-00123 - Obter licença para usar o Microsoft Word  
										</span>
										<div class="progress mt-1 w-100">
											<div class="progress-bar" role="progressbar" title="Progresso 33%" 
												style="font-size: 11px; height: 3px; width: 33%;">
											</div>     
										</div> 
									</td>
									<td>
										<i class="far fa-calendar-alt"></i>
										27/10/2021 a 30/10/2021
									</td>
									<td class="text-right">
										R$ 120,50
									</td>
								</tr>
							</table>  
						</div>
					</div>
					<div class="bg-light" style="height: 25px;">
						&nbsp;
					</div>
				</div>
			</slide>
			
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>
		-->

		<!--
        <div class="p-1 mt-1">
            <div class="row">
                <div class="col">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
							<i class="far fa-calendar-plus mr-1"></i>
                            Projetos reagendados
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            4
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
							<i class="far fa-calendar-plus mr-1"></i>
                            Atividades reagendadas
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            9
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
							<i class="far fa-calendar-check mr-1"></i>
                            Projetos concluídos esse mês
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            5
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
							<i class="far fa-calendar-times mr-1"></i>
                            Projetos cancelados esse mês
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            1
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
							<i class="fas fa-users mr-1"></i>
                            Quantidade Grupo de Trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            7
                        </div>
                    </div>
                </div>
            </div>
        </div>
		-->

		<!-- TABELA RELAÇÃO COLABORADORES-->
        <div class="p-1 mt-1">
            <div class="row">
                <div class="col">
					<div :class="(expandirTabela) ? '' : 'table-container'">
						<table class="table table-hover sticky-table" style="line-height: 1.1;">
							<thead>
								<tr><th rowspan="2"> <span class="ml-5">
									<el-tooltip :content="(expandirTabela) ? 'Retrair a lista dos colaboradores' : 'Expandir a lista dos colaboradores'" placement="top">
										<i @click="expandirRetrair" class="opcaoExpansao clickable"
											:class="(expandirTabela) ? 'fas fa-minus' : 'fas fa-plus'"></i>
									</el-tooltip> Colaboradores</span> </th><th colspan="9" class="text-center"> Projetos </th><th colspan="7" class="text-center" style="border-left: 1px #ccc solid"> Atividades </th></tr>
								<tr style="background-color: #f4f6f7;"><th class="text-center titulo-NI"> NI </th><th class="text-center titulo-EA"> EA </th><th class="text-center titulo-AT"> AT </th><th class="text-center"> VA </th><th class="text-center titulo-RA"> RA </th><th class="text-center titulo-CO"> CO </th><th class="text-center"> RJ </th><th class="text-center titulo-CA"> CA </th><th class="text-center"> T </th><th class="text-center titulo-NI"> NI </th><th class="text-center titulo-EA"> EA </th><th class="text-center titulo-AT"> AT </th><th class="text-center titulo-RA"> RA </th><th class="text-center titulo-CO"> CO </th><th class="text-center titulo-CA"> CA </th><th class="text-center" style="border-right: 1px #ccc solid"> T </th></tr>
							</thead>
							<tbody>
								<tr v-if="listaColaboradores.length == 0">
									<td colspan="17" class="text-center"> 
										<span class="spinner-border spinner-border-sm mr-2" role="status">
											<span class="sr-only">Loading...</span>
										</span>Carregando colaboradores...
									</td>
								</tr>
								<tr v-for="colab in listaColaboradores" :key="colab.usuario.idusuario">
									<td class="fonte-pequena">
										<div class="row">
											<div class="col-1">
												<img :src="colab.usuario.avatar" :title="colab.usuario.apelido" width="27" height="27" class="rounded-circle ml-2 mr-2">
											</div>
											<div class="col ml-3 mt-1">
												{{ colab.usuario.nome }}
											</div>
										</div>
									</td>	
									<td class="text-center titulo-NI">{{ (colab.pSitNI == 0) ? "-" : colab.pSitNI }}</td>
									<td class="text-center titulo-EA">{{ (colab.pSitEA == 0) ? "-" : colab.pSitEA }}</td>
									<td class="text-center titulo-AT">{{ (colab.pSitAT == 0) ? "-" : colab.pSitAT }}</td>
									<td class="text-center">{{ (colab.pSitVA == 0) ? "-" : colab.pSitVA }}</td>
									<td class="text-center titulo-RA">{{ (colab.pSitRA == 0) ? "-" : colab.pSitRA }}</td>
									<td class="text-center">{{ (colab.pSitCO == 0) ? "-" : colab.pSitCO }}</td>
									<td class="text-center titulo-CO">{{ (colab.pSitRJ == 0) ? "-" : colab.pSitRJ }}</td>
									<td class="text-center titulo-CA">{{ (colab.pSitCA == 0) ? "-" : colab.pSitCA }}</td>
									<td class="text-center fundoTotal">{{ (colab.pSitTT == 0) ? "-" : colab.pSitTT }}</td>
									<td style="border-left: 1px #ccc solid" class="text-center titulo-NI">{{ (colab.aSitNI == 0) ? "-" : colab.aSitNI }}</td>
									<td class="text-center titulo-EA">{{ (colab.aSitEA == 0) ? "-" : colab.aSitEA }}</td>
									<td class="text-center titulo-AT">{{ (colab.aSitAT == 0) ? "-" : colab.aSitAT }}</td>
									<td class="text-center titulo-RA">{{ (colab.aSitRA == 0) ? "-" : colab.aSitRA }}</td>
									<td class="text-center titulo-CO">{{ (colab.aSitCO == 0) ? "-" : colab.aSitCO }}</td>
									<td class="text-center titulo-CA">{{ (colab.aSitCA == 0) ? "-" : colab.aSitCA }}</td>
									<td style="border-right: 1px #ccc solid" class="text-center fundoTotal">{{ (colab.aSitTT == 0) ? "-" : colab.aSitTT }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-12 quadroLegenda text-right mt-1">
						<span class="titulo-NI">NI - Não Iniciado</span> &nbsp; <span class="titulo-EA">EA - Em Andamento</span> &nbsp; <span class="titulo-AT">AT - Atrasado</span> &nbsp; VA - Em Validação &nbsp; <span class="titulo-RA">RA - Reagendada</span> &nbsp; <span class="titulo-CO">CO - Concluído</span> &nbsp; RJ - Rejeitado &nbsp; <span class="titulo-CA">CA - Cancelado</span> &nbsp; <span>T - Total</span>
					</div>
				</div>
			</div>
		</div>


		<modal
			:show.sync="modals.modalDetalhes"
			size="lg"
			modal-classes="modal-detalhes-inicio"
			:fechar-click="true"
		>
			<div class="text-right iconeFecharModal">
				<span @click="modals.modalDetalhes = false" class="pull-right clickable close-icon"><i class="fa fa-times"></i></span>
			</div>
			<InicioDetalhesModal :titulo="tituloDetalhes" :tipo="tipoDetalhes" :itens="listaDetalhes"
				:carregando="carregandoDetalhes" @selecionar="selecionarDetalhe" />
		</modal>

		<modal id="modalAtv" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade"
				@fechar-atividade="closeModalAtividade" @abrir-projeto="abrirModalProjeto"
				:atividadeSelecionada=atividadeModal />
		</modal>

		<modal id="modalProj" :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i
						class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" @fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade" :projetoSelecionado=projetoModal />
		</modal>		

    </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import Torta from "./graficos/Torta.vue";
import Linha from "./graficos/Linha.vue";
import Barra from "./graficos/Barra.vue";
import Donuts from "./graficos/Donuts.vue";
import Atividade from "@/components/Atividade.vue";
import Projeto from "@/components/Projeto.vue";
import InicioDetalhesModal from "@/components/InicioDetalhesModal.vue";

export default {
    name: 'InicioCoordenador',
	props: {
		modoDiretor: {
			type: Boolean,
			default: false,
		},
		periodo: {
			type: Object,
			required: true,
		},
	},
	components: {
		Torta, Linha, Barra, Donuts,
		Hooper, Slide,
		HooperNavigation,
		HooperPagination,
		Atividade,
		Projeto,
		InicioDetalhesModal,
	},
	data() {
		return {
			projetosPendentes: ["!?", "!?"],
			patProxDias: ["!?", "!?", "!?"],
			qntdMeusGT: ["!?", "!?"],
			listaSituacaoProjeto: [{},{},{},{},{}], 
			listaSituacaoAtividade: [{},{},{},{},{}],
			listaSituacaoTarefa: [{},{},{},{},{}],
			qntdProjeto: 0,
			qntdAtividade: 0,
			qntdTarefa: 0,
			listaGTCarrossel: [],
			listaGTAtividadeCarrossel: [],
			totalProjetosPendentes: [],
			listaColaboradores: [],
			totalUsuariosPendentes : null,
			totalProjetoPrevisto30Dias : '!?',
			totalAtividadesPrevisto15Dias : '!?',
			totalProjetoPendente: null,
            datasetSituacaoProjetoGT: [null],
            datasetSituacaoAtividadeGT: [null],
            datasetProjeto: null,
            datasetAtividade: null,
            datasetTarefa: null,
            datasetQntProjetoFuturo: null,
            datasetProjetoPorGT: null,
            datasetAtvProgramadaPorGT: null,
            datasetInvestPorGT: null,
			expandirTabela: false,
			carregandoProjetoCarrossel: true,
			carregandoAtividadeCarrossel: true,
			investimento: ["R$ 888.88", "R$ 888.88", "R$ 888.88", "R$ 888.88"],
			investimentoGT: "R$ 888.88",
			modals: {
				modalProjeto: false,
				modalAtividade: false,
				modalDetalhes: false,
			},
			listaDetalhes: [],
			tituloDetalhes: "",
			tipoDetalhes: "projeto",
			carregandoDetalhes: false,
			erroFiltroNotificado: false,
			projetoModal: null,
			atividadeModal: null,
            optionsDonut: {
                responsive: true,
                maintainAspectRatio: false,
				legend: {
					display: true,
				},
            },
            optionsTorta: {
                responsive: true,
                maintainAspectRatio: false,
				legend: {
					display: false,
				},
            },
            optionsBarraInvertido: {
                responsive: true,
                maintainAspectRatio: false,
				legend: {
					display: false,
				},
				scales: {
					xAxes: [{
						gridLines: {
							display: true,
						},
						ticks: {
							precision: 0,
						},
					}],
					yAxes: [{
						maxBarThickness: 34,
						categoryPercentage: 0.8,
						barPercentage: 0.8,
						gridLines: {
							display: true,
						},
						ticks: {
							display: true,
						},
					}],
				},		
            }
		};
	},
	created() {
        //this.fillData();
		this.carregarTela(true);
	},
	watch: {
		periodo: {
			deep: true,
			handler() {
				this.carregarTela(false);
			},
		},
	},
	computed: {
		optionsBarraProjeto() {
			return this.criarOptionsBarra(this.datasetProjetoPorGT);
		},
		optionsBarraAtividade() {
			return this.criarOptionsBarra(this.datasetAtvProgramadaPorGT);
		},
		nomeAgrupamento() {
			return this.modoDiretor ? "Coordenação" : "GT";
		},
		nomeAgrupamentoPlural() {
			return this.modoDiretor ? "Coordenações" : "Grupos de Trabalho";
		},
	},
	methods: {
		configPeriodo() {
			const params = {};
			if (this.periodo.dataInicio) params.dataInicio = this.periodo.dataInicio;
			if (this.periodo.dataFim) params.dataFim = this.periodo.dataFim;
			return {
				params,
				timeout: 60000,
				validateStatus: status => status === 200,
			};
		},
		abrirDetalhes(indicador, titulo, tipo) {
			this.erroFiltroNotificado = false;
			this.tituloDetalhes = titulo;
			this.tipoDetalhes = tipo;
			this.listaDetalhes = [];
			this.carregandoDetalhes = true;
			this.modals.modalDetalhes = true;
			const perfil = this.modoDiretor ? "diretor" : "coordenador";
			this.$clubApi.get(`/inicio/${perfil}/detalhe/${indicador}`, this.configPeriodo()).then((response) => {
				this.listaDetalhes = response.data.object || [];
			}).catch((error) => {
				this.notificarErroFiltro(error);
			}).finally(() => {
				this.carregandoDetalhes = false;
			});
		},
		selecionarDetalhe(item) {
			this.modals.modalDetalhes = false;
			this.$nextTick(() => {
				if (this.tipoDetalhes === "projeto") this.abrirModalProjeto(item);
				else this.abrirModalAtividade(item);
			});
		},
		criarOptionsBarra(dataset) {
			const options = JSON.parse(JSON.stringify(this.optionsBarraInvertido));
			if (dataset && dataset.labels && dataset.labels.length === 1) {
				options.scales.yAxes[0].barThickness = 34;
			}
			return options;
		},
		agrupamentoNome(item) {
			return this.modoDiretor ? item.coordenacao.nome : item.grupoTrabalho.nome;
		},
		agrupamentoId(item) {
			return this.modoDiretor ? item.coordenacao.idcoordenacao : item.grupoTrabalho.idgt;
		},
		irProjeto() {
			location.href = '/projeto-listagem';
		},
		irProjetoValidacao() {
			location.href = '/projeto-validacao';
		},
		irProjetoPendente() {
			location.href = '/projeto-pendente';
		},
		irAtividade() {
			location.href = '/atividade-listagem';
		},
		async carregarTela(incluirAtemporais) {
			this.erroFiltroNotificado = false;
			this.$emit("carregando", true);
			try {
				const requisicoes = [
					this.carregarPAT(),
					this.carregarProjetosCarrossel(),
					this.carregarProjetosPorGT(),
					this.carregarAtvProgramadaPorGT(),
					this.carregarAtividadesCarrossel(),
					this.carregarPATProxDias(),
					this.totalProjetosComPendencias(),
					this.carregarInvestimentos(),
					this.carregarTabelaColaboradores(),
				];
				if (incluirAtemporais) {
					requisicoes.push(this.carregarInvestimentosGT());
					if (!this.modoDiretor) requisicoes.push(this.totalUsuariosComPendencias());
				}
				await Promise.allSettled(requisicoes);
			} catch (error) {
				this.notificarErroFiltro(error);
			} finally {
				this.$emit("carregando", false);
			}
		},
		mensagemErro(error) {
			return error && error.response && error.response.data && error.response.data.msg
				? error.response.data.msg
				: "Não foi possível concluir o carregamento dos dados.";
		},
		notificarErroFiltro(error) {
			if (this.erroFiltroNotificado) return;
			this.erroFiltroNotificado = true;
			this.$toastr.warning(this.mensagemErro(error));
		},
		expandirRetrair() {
			this.expandirTabela = !this.expandirTabela;
		},
		carregarProjetoPendentes() {
			return this.$clubApi.get("/inicio/coordenador/projeto/pendente", this.configPeriodo()).then((response) => {
				this.projetosPendentes = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		carregarTabelaColaboradores(){
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/tabela" : "/inicio/coordenador/tabela",
				this.configPeriodo()).then((response) => {
				this.listaColaboradores = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},

		carregarPAT() {
			const projetos = this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/projeto" : "/inicio/coordenador/projeto",
				this.configPeriodo()).then((response) => {
				this.listaSituacaoProjeto = response.data.object;
				this.qntdProjeto = this.listaSituacaoProjeto.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetProjeto = {
					labels: ["Não Iniciados", "Em Andamento", "Atrasados", "Cancelados", "Concluídos"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoProjeto[0].quantidade, this.listaSituacaoProjeto[1].quantidade, 
							this.listaSituacaoProjeto[2].quantidade, this.listaSituacaoProjeto[3].quantidade, 
							this.listaSituacaoProjeto[4].quantidade]
					}]
				};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			const atividades = this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/atividade" : "/inicio/coordenador/atividade",
				this.configPeriodo()).then((response) => {
				this.listaSituacaoAtividade = response.data.object;
				this.qntdAtividade = this.listaSituacaoAtividade.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetAtividade = {
					labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoAtividade[0].quantidade, this.listaSituacaoAtividade[1].quantidade, 
							this.listaSituacaoAtividade[2].quantidade, this.listaSituacaoAtividade[3].quantidade, 
							this.listaSituacaoAtividade[4].quantidade]
					}]
				};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			const tarefas = this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/tarefas" : "/inicio/coordenador/tarefas",
				this.configPeriodo()).then((response) => {
				this.listaSituacaoTarefa = response.data.object;
				this.qntdTarefa = this.listaSituacaoTarefa.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetTarefa = {
					labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoTarefa[0].quantidade, this.listaSituacaoTarefa[1].quantidade, 
							this.listaSituacaoTarefa[2].quantidade, this.listaSituacaoTarefa[3].quantidade, 
							this.listaSituacaoTarefa[4].quantidade]
					}]
				};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			return Promise.allSettled([projetos, atividades, tarefas]);
		},
		carregarInvestimentos() {
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/investimento" : "/inicio/colaborador/investimento",
				this.configPeriodo()).then((response) => {
				this.investimento = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		carregarInvestimentosGT() {
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/investimento/gt" : "/inicio/coordenador/investimento/gt").then((response) => {
				this.investimentoGT = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		totalProjetosComPendencias() {
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/projetos/pendentes" : "/inicio/coordenador/projetos/pendentes",
				this.configPeriodo()).then((response) => {
				this.totalProjetosPendentes = response.data.object;
				this.projetosPendentes = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		carregarPATProxDias() {
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/pat/dias" : "/inicio/coordenador/pat/dias",
				this.configPeriodo()).then((response) => {
				this.patProxDias = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		totalUsuariosComPendencias() {
			return this.$clubApi.get("/inicio/coordenador/usuarios/pendentes").then((response) => {
				this.totalUsuariosPendentes = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
        fillData() {
			this.datasetInvestPorGT = {
				labels: ['PR2021-00123', 'PR2021-00142', 'PR2021-00133', 'PR2021-01123'],
				datasets: [{
					axis: 'y',
					label: 'Investimento',
					backgroundColor: 'rgba(150, 150, 150, 0.6)',
					data: ["302.90", "212.25", "313.56", "420.50"]
				}]
			};
			this.datasetQntProjetoFuturo = {
				labels: ["1Q Jun", "2Q Jun", "1Q Jul", "2Q Jul", "1Q Ago", "2Q Ago"],
				datasets: [{
					label: "Projetos",
					data: [34, 54, 41, 45, 67, 78],
					fill: true,
					borderColor: 'rgb(75, 192, 192)',
					tension: 0.15
				}]
			};
            this.datasetProjeto = {
				labels: ["Não Iniciados", "Em Andamento", "Atrasados", "Concluídos", "Cancelados"],
                datasets: [
                    {
					borderWidth: 0.5,
                    backgroundColor: [
                        '#ccc',
                        '#65a1d1',
                        '#DD1B16',
                        '#28a745',
                        '#E46651',
                    ],
                    data: [12, 7, 5, 17, 2]
                    }
                ]
            };
            this.datasetAtividade = {
				labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Concluídas", "Canceladas"],
                datasets: [
                    {
					borderWidth: 0.5,
                    backgroundColor: [
                        '#ccc',
                        '#65a1d1',
                        '#DD1B16',
                        '#28a745',
                        '#E46651',
                    ],
                    data: [7, 32, 11, 3, 2]
                    }
                ]
            };
        },
		formatarMoeda(value) {
			let numericValue = value.replace(/[^\d,.-]/g, '');
			numericValue = numericValue.replace(/\./g, '');
			numericValue = numericValue.replace(/\,/g, '');
			numericValue = numericValue.substring(0, numericValue.length-2) +"."+ numericValue.substring(numericValue.length-2, numericValue.length);
			numericValue = parseFloat(numericValue);
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}).format(numericValue);
		},
        carregarProjetosCarrossel() {
			this.carregandoProjetoCarrossel = true;
			this.datasetSituacaoProjetoGT = [];

			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/coordenacao/projeto" : "/inicio/coordenador/grupotrabalho/projeto",
				this.configPeriodo()).then((response) => {
				
				this.listaGTCarrossel = response.data.object;

				let index = 0;
				this.listaGTCarrossel.forEach((gt) => {
					this.datasetSituacaoProjetoGT[index++] = {
						labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
						datasets: [{
							borderWidth: 0.5,
							backgroundColor: ['#ccc', '#65a1d1', '#DD1B16', '#E46651', '#28a745'],
							data: [gt.listaSituacao[0].quantidade, gt.listaSituacao[1].quantidade, 
									gt.listaSituacao[2].quantidade, gt.listaSituacao[3].quantidade, 
									gt.listaSituacao[4].quantidade]
						}]
					};
					gt.qntdProjetos = gt.listaSituacao[0].quantidade + gt.listaSituacao[1].quantidade + gt.listaSituacao[2].quantidade + gt.listaSituacao[3].quantidade + gt.listaSituacao[4].quantidade;
				});
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			})
			.finally(() => {
				this.carregandoProjetoCarrossel = false;
			});
        },
		carregarProjetosPorGT() {
			
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/projeto/coordenacao" : "/inicio/coordenador/projeto/grupotrabalho",
				this.configPeriodo()).then((response) => {
				
				let listaGT = response.data.object;
				let listaLabel = [];
				let listaQntd = [];
				
				listaGT.forEach((gt) => {
					if (gt.nomeGT.length > 35) {
						listaLabel.push(gt.nomeGT.substring(0, 35) +"...");
					} else {
						listaLabel.push(gt.nomeGT);
					}
					listaQntd.push(gt.quantidade);
				});
				
				this.datasetProjetoPorGT = {
					labels: listaLabel,
					datasets: [{
						label: 'Projetos',
						backgroundColor: '#008aa3',
						data: listaQntd
					}]
				};
				
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		carregarAtvProgramadaPorGT() {
			
			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/atividade/coordenacao" : "/inicio/coordenador/atividade/grupotrabalho",
				this.configPeriodo()).then((response) => {
				
				let listaGT = response.data.object;
				let listaLabel = [];
				let listaQntd = [];
				
				listaGT.forEach((gt) => {
					if (gt.nomeGT.length > 35) {
						listaLabel.push(gt.nomeGT.substring(0, 35) +"...");
					} else {
						listaLabel.push(gt.nomeGT);
					}
					listaQntd.push(gt.quantidade);
				});

				this.datasetAtvProgramadaPorGT = {
					labels: listaLabel,
					datasets: [{
						label: 'Quantidade de Atividades',
						backgroundColor: '#f97a2f',
						data: listaQntd
					}]
				};
				
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
        carregarAtividadesCarrossel() {
			this.carregandoAtividadeCarrossel = true;
			this.datasetSituacaoAtividadeGT = [];

			return this.$clubApi.get(this.modoDiretor ? "/inicio/diretor/coordenacao/atividade" : "/inicio/coordenador/grupotrabalho/atividade",
				this.configPeriodo()).then((response) => {
				
				this.listaGTAtividadeCarrossel = response.data.object;
				
				let index = 0;
				this.listaGTAtividadeCarrossel.forEach((gt) => {

					this.datasetSituacaoAtividadeGT[index++] = {
						labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
						datasets: [{
							borderWidth: 0.5,
							backgroundColor: [
								'#ccc',
								'#65a1d1',
								'#DD1B16',
								'#E46651',
								'#28a745',
							],
							data: [gt.listaSituacao[0].quantidade, gt.listaSituacao[1].quantidade, 
									gt.listaSituacao[2].quantidade, gt.listaSituacao[3].quantidade, 
									gt.listaSituacao[4].quantidade]
						}]
					};
					gt.qntdProjetos = gt.listaSituacao[0].quantidade + gt.listaSituacao[1].quantidade + gt.listaSituacao[2].quantidade + gt.listaSituacao[3].quantidade + gt.listaSituacao[4].quantidade;
				});
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			})
			.finally(() => {
				this.carregandoAtividadeCarrossel = false;
			});
        },
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
    },
}
</script>
<style>
.clickable {
	cursor: pointer;
}
.clickable:hover {
	cursor: pointer;
	text-decoration: none !important;
}
.w-98 {
    width: 99%;
}
.font-bold-500 {
	font-weight: 500;
}
.bg-pendencia {
    background-color: #fdeef0 !important;
    border: 1px solid #f5d4d9 !important;
}
.janelaPequena {
    border: 1px solid white;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    box-shadow: 0 0 4px rgba(0,0,0,.125),0 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
    height: 110px;
	background-color: #f0f0f0;
}
.tituloJanelaPequena {
    font-size: 11px;
	margin-left: -20px;
}
.quadroPequeno {
    border: 1px solid #d4e5f3;
    background-color: #d0e3f3;
    border-radius: 4px;
    height: 90px;
}
.quadroPequenoCoord {
    border: 1px solid #d4e5f3;
    background-color: #d0e3f3;
    border-radius: 4px;
    height: 65px;
}
.tituloQuadroPequeno {
    height: 45px;
    font-size: 14px;
}
.quadroLegenda {
    height: 45px;
    font-size: 11px;
}
.tituloQuadroPequenoCoord {
    height: 25px;
    font-size: 13px;
}
.fonte-grande {
    font-size: 42px;
}
.fonte-media {
    font-size: 24px;
}
.fonte-13 {
    font-size: 13px !important;
}
.fonte-pequena {
    font-size: 15px;
}
.fonte-pendencia {
    color: #dc3545
}
.grafico-pequeno {
    height: 300px;
}
.grafico-proj-gt {
    height: 250px;
	width: 100% !important;
	max-width: none !important;
	margin-left: 0;
}
.grafico-proj-gt canvas {
	width: 100% !important;
	max-width: none !important;
}
.grafico-invgt {
    height: 280px;
}
.grafico-situacao {
    height: 240px;
}
.titulo-NI {
    color: #6d6d6d;
}
.titulo-EA {
    color: #65a1d1;
}
.titulo-AT {
	color: #DD1B16;
}
.titulo-CO {
    color: #28a745;
}
.titulo-CA {
    color: #E46651;
}
.fundoTotal{
	background-color: #f5f5f5;
}
</style>
